import React, { useEffect, useState } from 'react';
import { useBOMStore } from "../../../../hooks/bom";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import BOM from "@system/config/bom";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import { Tooltip } from 'src/component/Global/Tooltip';
import { useCartStore } from 'src/hooks/cart';
import alertic from 'src/assets/images/yellow-alert.png';
import AddPartAutoComplete from 'src/component/custom/AddPartAutoComplete'
import lifecyclered from "src/assets/images/lifecycle-red.png";
import lifecyclegreen from "src/assets/images/lifecycle-green.png";
import lifecycleyellow from "src/assets/images/lifecycle-yellow.png";
import lifecycleunknown from "src/assets/images/lifecycle-unknown.png";
import { isArray } from "underscore";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const BomTabsData = () => {
    const params = System.getParams();
    const [__check] = useAxiosIndicatorCheck();
    const [{ bom_detail_by_bom_id_type, bom_detail_Exact_list, bom_detail_Multiple_list, bom_detail_NoMatch_list, bom_detail_by_bom_id, bom_health_by_bom_id }, { get_bom_detail_by_bom_id, get_bom_health_by_bom_id, get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { add_part_to_bom, set_is_rematch_flag, create_params_for_add_part_to_bom, update_quantity_by_bom_detail_by_id,remove_all_selected_fields }] = useBOMStore();
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [displayBomHealthButton, setDisplayBomHealthButton] = useState(true)
    const bom_id = params.bomId;
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [displayInvalidQuantityBanner, setDisplayInvalidQuantityBanner] = useState([])
    const [showMessageNoExactMatchData, setShowMessageNoExactMatchData] = useState(true)
    const { translation: t } = System;

    useEffect(() => {
        setDisplayBomHealthButton(true)
    }, [bom_detail_Exact_list?.count])

    useEffect(() => {
        async function fetchHere() {
            if (Object.entries(productSelected).length > 0) {
                let params = await create_params_for_add_part_to_bom({ ...productSelected, bomIds: [bom_id] })

                await add_part_to_bom(params).then(async (res) => {
                    if (res) {
                        // setProductSelected({}) commented for now 
                        setSearchTerm('')
                        await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id, true)
                    }
                })
            }
        }

        fetchHere()
    }, [productSelected]);

    const checkBomHealth = async () => {
        await get_bom_health_by_bom_id({ bomId: bom_id })
        setDisplayBomHealthButton(false)
        bomHealthCTA()
    };

    const renderTooltip = (props) => (
        <div>
            <div className="text-center">{t('lowRiskContent')}</div><br />
            <div className="text-center">{t('mediumRiskContent')}</div><br />
            <div className="text-center">{t('highRiskContent')}</div>
        </div>
    );

    const bomHealthCTA = () => {
        let linkDetails = {
            linkName: "Check bom health",
            linkUrl: window.location.href,
            linkLocation: window.document.title,
            linkType: "Button",
            linkComponent: "BOM Page",
        }
        HelperAnalyticsEvent.ctaClickEvent({ linkInfo: linkDetails })
    }

    useEffect(() => {
        const bomRecord = bom_detail_Exact_list?.records
        const getQuantityOBJ = bomRecord &&
            Object.entries(bomRecord)
                .map(x => {
                    const productList = CART_BEFORE_TO_SEND_SERVER[x[1].itemNumber]
                    const checkValid = System.checkValidQuantity(productList, x[1]?.quantity)
                    if (checkValid && !x[1].isDeleted) {
                        const getNearestMultiple = (num, multiple, min) => {
                            return num <= min ? min : Math.ceil(num / multiple) * multiple;
                        };
                        return {
                            bomDetailsId: x[0],
                            quantity: getNearestMultiple(x[1]?.quantity, productList?.QtyMult, productList?.QtyMin)
                        };

                    }
                })
                .filter(Boolean);
        setDisplayInvalidQuantityBanner(getQuantityOBJ)
    }, [CART_BEFORE_TO_SEND_SERVER, bom_detail_by_bom_id_type])

    const updateAllQuantity = async () => {
        await update_quantity_by_bom_detail_by_id(displayInvalidQuantityBanner);
        await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id)
        remove_all_selected_fields()
    }

    const getImageOnStatus = (status) => {
        const result = status === 'low'? lifecyclegreen : status === 'med' ? lifecycleyellow : status === 'high' ? lifecyclered : status === 'unknown' ? lifecycleunknown : false
        return result;
    };
    return (
        <>
            {__check(['BOM_REMATCH_FLAG_OPERATION_API_CALL']).render}

            {!bom_detail_by_bom_id?.isRematched &&
                <div className="table-outline justify-content-center mb-0 mt-3 p-3 bg-light text-center">
                    <span className="font-16 font-bold text-black me-1 font-arial">{t('haveWeMatchedYourColumnsCorrectly')}
                        <a
                            href={void (0)}
                            onClick={async () => {
                                await set_is_rematch_flag({ bomId: bom_id });
                                await get_bom_detail_by_bom_id({ bomId: bom_id });
                            }} className="text-blue2 ms-1 me-1 text-uppercase"><u>Yes</u></a>
                        |
                        <a href={BOM.getBomRematchRouteURL({ bomId: bom_id })} className="text-blue2 ms-1 text-uppercase"><u>No</u></a>,
                        <a href={BOM.getBomRematchRouteURL({ bomId: bom_id })}
                            className="text-blue2 ms-1"><u>{t('rematchColumn')}</u></a></span>
                </div>
            }

            {displayInvalidQuantityBanner?.length ?
                <div className="alert alert-danger mb-0 mt-3">
                    <span>{t('forProcessingWithAvnetYouHave')} <b>{displayInvalidQuantityBanner?.length} {t('parts')}</b> {t('invalidMinMultUpdateManually')}  <a href={void (0)} onClick={() => {
                        updateAllQuantity()
                    }}><b><u>{t('clickHere')} </u></b> </a>{t('toResolveAllAutomatically')}</span>
                    <img className="ms-auto" src={alertic} alt="Alert icon" />
                </div>
                : ''
            }

            {showMessageNoExactMatchData && (bom_detail_NoMatch_list?.count > 0 || bom_detail_Multiple_list?.count > 0) ?
                <div className="bs5 row mt-3 pt-2">
                    <div className="col-lg-12">
                        <div className="alert alert-info mb-0" role="alert">
                            <span>
                                {t('youHave')} <b>{bom_detail_NoMatch_list.count + bom_detail_Multiple_list?.count}</b> {t('partsThatAreNotExactMatches')}
                            </span>
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => setShowMessageNoExactMatchData(false)} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                    </div>
                </div> : ''
            }
            <div className="overall-bom-header mb-3 mb-lg-0">
                <div className="overall-bom-left">

                    <div className="d-flex align-items-center mb-3 flex-wrap">
                        <h5 className="me-2 mt-0 mb-0"><span className='me-1 text-black'>{t('exactMatchBomHealth')}</span>
                            <Tooltip
                                position={'bottom center'}
                                opener={() => (
                                    <i className="fa fa-info-circle font-15"></i>
                                )}
                                content={() => (
                                    renderTooltip()
                                )}
                            />

                        </h5>
                        {__check('BOM_HEALTH_API_CALL', { inline: true }).render}
                        {!__check(['BOM_HEALTH_API_CALL']).status && displayBomHealthButton &&
                            <button className="bs5 btn btn-secondary me-4" onClick={async () => { await checkBomHealth() }}>{t('checkBomHealth')}</button>
                        }

                        {!displayBomHealthButton &&
                            <ul className="list-unstyled list-inline m-0">
                                {bom_health_by_bom_id && isArray(bom_health_by_bom_id) && bom_health_by_bom_id.length > 0 &&
                                    bom_health_by_bom_id.map((v, i) => (
                                        <li className="me-1" key={i}>
                                            {getImageOnStatus(v.lifeCycleRisk.toLowerCase()) &&
                                                <img className="me-2" src={getImageOnStatus(v.lifeCycleRisk.toLowerCase())} alt={''} />
                                            }
                                            <span>{v.percentage} {v.lifeCycleRisk.toLowerCase() === 'med' ? 'Medium' : v.lifeCycleRisk.charAt(0).toUpperCase() + v.lifeCycleRisk.slice(1).toLowerCase()}</span>
                                        </li>
                                    ))
                                }
                            </ul>
                        }

                    </div>

                </div>
                <div className="overall-bom-right ms-0 ms-lg-auto">
                    <div className="d-flex align-items-center">
                        <label className="font-14 font-bold me-3 my-0">{t('quicklyAddAPart')}</label>
                        <AddPartAutoComplete fromComponent="bomTabs" isPriceInventoryCall={false} />
                    </div>
                    <div className="add-part-links">
                        <a className="add-part-link text-blue2" href={void (0)} data-toggle="modal" data-target="#add-parts"
                            onClick={() => { System.popup('CreatePartPopup', { title: t("addMultipleParts"), addFrom: "AddPart" }) }}>{t('addMultipleParts')}</a>

                        <a className="add-part-link text-blue2" href={void (0)} onClick={() => { System.popup('FindPartPopup', { title: "Add multiple parts", addFrom: "FindPart", no_match: false }) }}>{t('findAPart')}</a>

                        {bom_detail_by_bom_id_type.bomColumnMapping && Object.entries(bom_detail_by_bom_id_type.bomColumnMapping).length > 0 && bom_detail_Exact_list?.count !== bom_detail_by_bom_id_type?.totalMatches &&
                            <a className="add-part-link text-blue2" href={void (0)} onClick={() => { System.popup('BomEditColumnsPopup') }}>{t('addEditColumns')}</a>
                        }
                    </div>
                </div>
            </div>

        </>
    );
}

export default BomTabsData;